/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Product_BrochureInputs */

const en_doc_type_product_brochure = /** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Brochure`)
};

const id_doc_type_product_brochure = /** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brosur Produk`)
};

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const es_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const fr_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const de_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const ja_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const zh_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const ar_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const it_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const ru_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const pt_doc_type_product_brochure = en_doc_type_product_brochure;

/** @type {(inputs: Doc_Type_Product_BrochureInputs) => LocalizedString} */
const ko_doc_type_product_brochure = en_doc_type_product_brochure;

/**
* | output |
* | --- |
* | "Product Brochure" |
*
* @param {Doc_Type_Product_BrochureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_product_brochure = /** @type {((inputs?: Doc_Type_Product_BrochureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Product_BrochureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_product_brochure(inputs)
	if (locale === "es") return es_doc_type_product_brochure(inputs)
	if (locale === "fr") return fr_doc_type_product_brochure(inputs)
	if (locale === "de") return de_doc_type_product_brochure(inputs)
	if (locale === "ja") return ja_doc_type_product_brochure(inputs)
	if (locale === "zh") return zh_doc_type_product_brochure(inputs)
	if (locale === "ar") return ar_doc_type_product_brochure(inputs)
	if (locale === "id") return id_doc_type_product_brochure(inputs)
	if (locale === "it") return it_doc_type_product_brochure(inputs)
	if (locale === "ru") return ru_doc_type_product_brochure(inputs)
	if (locale === "pt") return pt_doc_type_product_brochure(inputs)
	return ko_doc_type_product_brochure(inputs)
});